export const YES_NO = { YES: 'Yes', NO: 'No' } as const;

export const PREMIUM_TYPE_OPTIONS = {
  PERCENTAGE: 'Percentage',
  AMOUNT: 'Amount'
} as const;

export const EXCESS_TYPE_OPTIONS = {
  PERCENTAGE: 'Percentage',
  AMOUNT: 'Amount',
  DAYS: 'Days'
} as const;
